module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.html
// module id = ./src/app/components/logout/logout.component.html
// module chunks = main